var _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStepCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 425,
    height: 260,
    viewBox: "0 0 425 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H119.508C121.437 0 123.302 0.6972 124.758 1.96316L131.742 8.03684C133.198 9.3028 135.063 10 136.992 10H417C421.418 10 425 13.5817 425 18V236.686C425 238.808 424.157 240.843 422.657 242.343L407.343 257.657C405.843 259.157 403.808 260 401.686 260H8C3.58173 260 0 256.418 0 252V8Z",
    fill: "#111111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 8C0.25 3.71979 3.71979 0.25 8 0.25H119.508C121.377 0.25 123.183 0.925413 124.594 2.15181L131.578 8.22549C133.08 9.53101 135.002 10.25 136.992 10.25H417C421.28 10.25 424.75 13.7198 424.75 18V236.686C424.75 238.742 423.933 240.713 422.48 242.166L407.166 257.48C405.713 258.933 403.742 259.75 401.686 259.75H8C3.7198 259.75 0.25 256.28 0.25 252V8Z",
    stroke: "white",
    strokeOpacity: 0.35,
    strokeWidth: 0.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 425,
    height: 44,
    transform: "translate(0 36)",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepCard);
export default __webpack_public_path__ + "static/media/stepCard.c9c78c968983e00d157832cad472db32.svg";
export { ForwardRef as ReactComponent };